import { getComposeEvent } from 'owa-calendar-compose-store-manager';
import { lazyTriggerLocationsChangedEvent } from 'owa-addins-core';

export default function triggerLocationsChanged(formId: string) {
    const calendarEvent = getComposeEvent(formId);
    lazyTriggerLocationsChangedEvent
        .import()
        .then(triggerLocationsChangedEvent =>
            triggerLocationsChangedEvent(formId, calendarEvent.Locations)
        );
}
